export default function digitsExempt() {
  return (value) => {
    if (!value) return;
    if (/\d/.test(value)) {
      return 'errors.formFields.no.digits';
    }
  };
}
